export const LINKSNAVBAR = [
  {
    key: 1,
    name: "Home",
    link: "home",
  },
  {
    key: 2,
    name: "About",
    link: "about",
  },
  {
    key: 3,
    name: "Experience",
    link: "experience",
  },
  {
    key: 4,
    name: "Projects",
    link: "projects",
  },
  {
    key: 5,
    name: "Contact",
    link: "contact",
  },
];
